import React, { useCallback, useEffect, useState } from 'react';
import Select from 'react-select';
import { useField } from 'react-final-form';

const SelectArrayField = ({
  label,
  name,
  isMulti,
  placeholder,
  options,
  value,
}) => {
  const { input } = useField(name);
  const [selectedItems, setSelectedItems] = useState([]);

  const handleChange = useCallback(
    (option) => {
      const newSelectedItems = option.map((o) => o.value);
      setSelectedItems(option);
      input.onChange(newSelectedItems);
    },
    [input],
  );

  const findInitialItems = () => {
    const selectedItems = value && value.map((v) => options.find((option) => option.value === v));
    setSelectedItems(selectedItems);
  };

  useEffect(() => {
    findInitialItems();
  }, [value]);
  return (
    <>
      {label && <label className="label">{label}</label>}
      <Select
        label={label}
        name={name}
        isMulti={isMulti}
        placeholder={placeholder}
        options={options}
        onChange={handleChange}
        value={selectedItems}
      />
    </>
  );
};

export default SelectArrayField;
